import { render, staticRenderFns } from "./change-info.vue?vue&type=template&id=3848451e&scoped=true"
import script from "./change-info.vue?vue&type=script&lang=js"
export * from "./change-info.vue?vue&type=script&lang=js"
import style0 from "./change-info.vue?vue&type=style&index=0&id=3848451e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848451e",
  null
  
)

export default component.exports